export default "__VITE_ASSET__Cj30m9dF__"